exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App Colors\n------------------------------------------------------------ */\n.printing-output {\n  margin: 10px 36px; }\n  .printing-output .title {\n    border-bottom: 1px #000000 solid;\n    text-align: right; }\n    .printing-output .title .letter {\n      margin-left: 10px;\n      font-size: 50px; }\n  .printing-output .loading {\n    color: #ff0000;\n    font-size: 60px;\n    text-align: right; }\n  .printing-output .entry {\n    font-size: 16px;\n    direction: rtl;\n    text-align: right;\n    white-space: pre-line; }\n  .printing-output .level-0,\n  .printing-output .level-1 {\n    margin-right: 0px; }\n  .printing-output .level-2 {\n    margin-right: 36px; }\n  .printing-output .level-3 {\n    margin-right: 72px; }\n  .printing-output .level-4 {\n    margin-right: 108px; }\n  .printing-output .level-5 {\n    margin-right: 144px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/printing-output-page/printing-output-page.scss
// module id = ../../../../../src/app/admin-area/containers/printing-output-page/printing-output-page.scss
// module chunks = main